import { EntityType } from 'UI/constants/entityTypes';

const KNOWN_SOURCING_TYPES = [EntityType.Candidate, EntityType.Company];

export const resolveSourcingType = rawType =>
  KNOWN_SOURCING_TYPES.includes(rawType) ? rawType : null;

export const normalizeSourcingMessage = data => {
  if (!data || data.count === undefined) return null;

  return {
    count: data.count || 0,
    description: data.version ? `Version: ${data.version}` : null,
    id: data.id
  };
};
